import { useMutation } from '@tanstack/react-query'

import { api } from '@services/apiClient'
import { queryClient } from '@services/queryClient'

import { useFindProfile } from './profile'

interface IFilterPayload {
  statusIds?: number[]
  areaIds?: number[]
  locationIds?: number[]
  supervisorIds?: number[]
  resourceIds?: number[]
  plantSectionIds?: number[]
  operationPostIds?: number[]
  assigneeIds?: number[]
  projectIds?: number[]
}

export const useSetFilters = () => {
  const { data: user } = useFindProfile()
  const siteId = user && user.selectedSite.id

  const postSelectedFilters = async (payload: IFilterPayload) => {
    const url = `me/filters/${siteId}`
    const { data } = await api.post(url, payload)
    return data
  }

  return useMutation({
    mutationFn: postSelectedFilters,
    onSuccess: () => {
      queryClient.refetchQueries({
        queryKey: ['PROFILE'],
        type: 'active',
      })
      queryClient.refetchQueries({
        queryKey: ['TASKS'],
        type: 'active',
      })
    },
  })
}
